<app-header></app-header>

<div class="page-title-area page-title-style-two item-rights">
    <div class="container">
        <div class="page-title-content">
            <ul>
                <li><a routerLink="/">Home</a></li>
                <li>Termeni si conditii GDPR</li>
            </ul>
            <h2>Termeni si conditii GDPR</h2>
        </div>
    </div>
</div>

<div class="about-area ptb-100">
    <div class="container">
        <div class="row">
            <div class="col-12">

                <h3>
                    Termeni si conditii GDPR
                </h3>
                <br>
                <p>
                    Continutul website-ului http://www.cmdtamp.ro (in continuare, denumiteb site) sunt proprietatea
                    exclusiva a entitatilor CMDTAMP.Bucuresti(in continuare, denumite generic Titularii si individual,
                    Titularul).
                    Titularii detin toate drepturile de proprietate intelectuala (inclusiv drepturile asupra bazelor de
                    date) privind marcile comerciale, marcile de servicii, logo-urile si toate celelalte materiale
                    prezentate in acest site, in lipsa de stipulati econtrara. Drepturile Titularilor sunt protejate
                    de legislatia romana in vigoare.
                </p>
                <p>
                    Site-urile sunt portale web de prezentare a serviciilor roferite, continand si o sectiune de
                    informatii medicale realizate de personal cu studii medicale si o platforma de programare
                    online/verificare rezultate medicale online.
                </p>
                <p>
                    Prin completarea formularelor puse la dispozitie vizitatorilor, persoanele interesate pot adresa
                    solicitari si informatii suplimentare cu privire la serviciile oferite de Titulari, pot formula
                    sugestii sau reclamatii.
                </p>
                <p>
                    Accesul utilizatorilor la serviciul Newsletter sau unele facilitati din cadrul site-ului necesita
                    inregistrarea utilizatorului cu o adresa de e-mail/numar pacient si, in unele cazuri, o parola. Va
                    recomandam sa protejati si sa nu dezvaluiti nimanui aceasta parola. Titularii nu vor cere niciodata
                    parola conturilor dumneavoastra prin mesaje, prin posta electronica sau telefon.

                    Titularii nu sunt si nu vor fi legal responsabili in niciun caz si pentru nicio inadvertenta ori
                    descriere eronata a informatiilor prezentate in site. Pentru a afla informatii detaliate si complete
                    despre serviciile puse la dispozitie de Titulari, puteti sa vaadresati resprezentantilor acestora
                    fie telefonic, fie in scris, utilizand datele de contact puse la dispozitie de fiecare Titular, la
                    sectiunile de contact dedicate.
                </p>
                <p>
                    Totodata, Titularii nu sunt responsabili in nicio masura de continutul furnizat de terte persoane,
                    de continutul sectiunilor publicitare, al mesajelor publicitare sau al continutului paginilo
                    rexterne la care se face trimitere din interiorul site-ului.
                </p>
                <p>
                    Niciunul dintre materialele care alcatuiesc continutul acestor site-uri nu constituie o oferta
                    ferma de a contracta si cu atat mai mult ele nu se constituie ca o oferta de vanzare-cumparare a
                    vreunui serviciu medical sau de asigurare.
                </p>
                <p>
                    Este interzisa reproducerea, distribuirea sau publicarea sub orice forma a continutului materialelor
                    prezentate pe acest site, indiferent de forma pe care acestea o imbraca, de catre orice persoana,
                    fara acordul scris prealabil al Titularului.
                </p>
                <p>
                    Titularii isi rezerva dreptul de a suspenda, modifica, adauga sau sterge in orice moment, portiuni
                    ale continutului site-ului. Totodata, Titularii isi rezerva dreptul de a restrictiona accesul
                    utilizatorilor la o parte sau la intregul sau continut din site.
                </p>
                <p>
                    Utilizatorii pot folosi continutul site-urilor doar pentru uzul personal si niciuna dintre actiunile
                    descrise mai jos nu sunt permise in lipsa obtinerii acordului prealabil scris al Titularului:
                </p>
                <ul>
                    <p>
                        1. Indepartarea sau alterarea continutului sau a insemnelor care identifica dreptul de autor al
                        titularului asupra continutului;
                    </p>
                    <p>
                        2. Modificarea, publicarea, transmiterea, retransmiterea in orice mod sau forma, precum si
                        participarea la transferul, vanzarea ori distributia unor materiale realizate prin reproducerea,
                        modificarea sau afisarea continutului, total sau partial, din site;
                    </p>
                    <p>
                        3. Reproducerea sau stocarea continutului, precum si trimiterea acestui continut catre orice alt
                        website, server sau orice alt mijloc de stocare a informatiei, daca scopul acestei activitati
                        este
                        unul comercial.
                    </p>
                </ul>
                <p>Orice actiune sau incercare de natura sa incalce prevederile de mai sus vor legitima Titularul sa
                    faca uz de dreptul de a se adresa instantelor de judecata legal competente pentru sanctionarea unei
                    asemenea fapte.</p>
                <p>Anumite parti ale continutului publicat pe site-uri pot sa fie furnizate de terte persoane cu care
                    site-urile au relatii contractuale in acest sens. De asemenea, in interiorul continutului
                    site-urilor
                    pot fi incluse sectiuni publicitare in care se vor afisa mesaje publicitare ale unor terte persoane.
                    Site-urile nu sunt responsabile in nici o masura asupra continutului furnizat de terte persoane,
                    indiferent ca acesta este publicitar sau nu. De asemenea, site-urile nu sunt responsabile de
                    continutul paginilor externe la care se face trimitere din interiorul sau.</p>

                <br>
                <br>

                <h4>Sugestii si reclamatii</h4>
                <br>
                <p>
                    Reclamatiile sau orice fel de sesizari ori sugestii referitoare la modalitatea de accesare a
                    site-urilor Titularilor sunt luate in considerare numai in baza unei adrese scrise din partea
                    vizitatorilor, transmisa in format electronic, completand formularul pus la dispozitie pepagina
                    feedback sau trimise catre adresa <b>office@cmdtamp.ro</b>

                    O reclamatie depusa in mod corespunzator cuprinde datele de identificare ale persoanei (prenume si
                    nume) precum si o descriere a problemei ce face obiectul reclamatiei. Totodata, reclamatia va trebui
                    sa cuprinda cel putin doua dintre urmatoarele date de contact: adresa, numar de telefon, numar de f
                    ax si adresa de e-mail.
                </p>
                <p>
                    Dupa primirea reclamatiei Titularul va lua imediat masurile necesare pentru solutionarea problemei
                    sesizate si, se angajeaza ca, in termen de maxim 30 de zile de la data primirii acesteia, sa trimita
                    un raspuns scris prin una dintre modalitatile de comunicare furnizate de conform prevederilor de
                    mai sus.
                </p>

                <br>
                <br>

                <h4>Cookies</h4>
                <br>
                <p>
                    Site-ul CMDTAMP.ro foloseste cookie-uri, acestea fiind date stocate pe hardul utilizatorului,
                    continand informatii despre acesta. Folosirea mecanismului de tip cookie reprezinta un avantaj in
                    folosul vizitatorilor, acesta permitand memorarea unor optiuni de navigare in site precum limba in
                    care se afiseaza site-ul, tip de filtre care se aplica la afisarea unor anumite pagini, memorare
                    numelui de utilizator si a parolei pentru un acces rapid la continutul site-ului etc.
                </p>
                <p>
                    Neacceptarea unui cookie nu inseamna ca utilizatorului ii va fi refuzat accesul de navigare in site,
                    de citire a continutului acestuia. Cu ajutorul cookie-urilor, proprietarii de site-uri pot
                    monitoriza
                    si segmenta interesele utilizatorilor fata de anumite zone sau aplicati ale site-ului, fapt care le
                    permite ulterior imbunatatirea experintei de navigare, introducerea unui continut relevant pentru
                    utilizator, etc.
                </p>

            </div>
        </div>
    </div>
</div>
